import { useCallback } from 'react';
import { api } from '../services/api';
import { useCatalog } from './useCatalog';

const toPresupuestoOption = (item) => ({
  value: String(item.cdPresupuesto),
  label: item.dePresupuesto,
  status: item.stPresupuesto,
});

const toTipoConceptoOption = (item) => ({
  value: String(item.tpConcepto),
  label: item.deTipoConcepto,
  status: item.stTipoConcepto,
});

const toConceptoOption = (item) => ({
  value: String(item.cdConcepto),
  label: item.deConcepto,
  type: String(item.tpConcepto),
  status: item.stConcepto,
});

export function usePresupuestos() {
  const fetchPresupuestos = useCallback(({ signal }) => api.getPresupuestos({ signal }), []);
  return useCatalog(fetchPresupuestos, { mapItem: toPresupuestoOption });
}

export function useTipoConceptos() {
  const fetchTipoConceptos = useCallback(({ signal }) => api.getTipoConceptos({ signal }), []);
  return useCatalog(fetchTipoConceptos, { mapItem: toTipoConceptoOption });
}

export function useConceptos() {
  const fetchConceptos = useCallback(({ signal }) => api.getConceptos({ signal }), []);
  return useCatalog(fetchConceptos, { mapItem: toConceptoOption });
}